import React from 'react';
import { Input } from 'antd';
import { AddedSection, AddedAttributeType, AddedAttribute } from 'pages/UserPage/components/MiddlePane/types';
import { updateAddedValue, updateSingletonValue } from '../../../updateAttributeValueUtils';
import StartOrEndTimePicker from './StartOrEndTimePicker';
import styles from '../AttributeTypeEditField.module.scss';

interface Props {
  addedSections: AddedSection[];
  attributes: AddedAttribute[];
  attributeTypeName: string;
  getAddedAttributeValue: (sectionName: string, attributeTypeName: string) => string | undefined;
  section: AddedSection;
  showAttributeEndTime: boolean;
  showAttributeStartTime: boolean;
  setAddedSections: (addedSections: AddedSection[]) => void;
  setUserAttributeTypes: (userAttributeTypes: AddedAttributeType[]) => void;
  userAttributeTypes: AddedAttributeType[];
}

const SingletonEditField = ({
  addedSections,
  attributes,
  attributeTypeName,
  getAddedAttributeValue,
  section,
  setAddedSections,
  showAttributeEndTime,
  showAttributeStartTime,
  setUserAttributeTypes,
  userAttributeTypes,
}: Props) => {
  let attributesToEdit;
  const activeAttribute = attributes.find(attribute => !attribute.end_date);
  if (showAttributeEndTime) {
    attributesToEdit = attributes;
  } else {
    attributesToEdit = activeAttribute ? [activeAttribute] : [{ value: '' }];
  }
  return (
    <>
      {attributesToEdit.map(attribute => (
        <div className={styles.attributeEditField} key={attributeTypeName + attribute.id}>
          <Input
            allowClear
            className={styles.editField}
            onChange={e => {
              const typeName = attributeTypeName;
              if (section.addedSection) {
                updateAddedValue(
                  section.name,
                  typeName,
                  e.target.value,
                  addedSections,
                  userAttributeTypes,
                  setUserAttributeTypes,
                  setAddedSections);
              } else {
                updateSingletonValue(
                  userAttributeTypes,
                  setUserAttributeTypes,
                  typeName,
                  { ...attribute, value: e.target.value });
              }
            }}
            value={attribute?.value || getAddedAttributeValue(section.name, attributeTypeName)}
          />
          {showAttributeStartTime && (
            <>
              {'from '}
              <StartOrEndTimePicker
                isStartTimePicker
                attribute={attribute}
                attributeTypeName={attributeTypeName}
                setUserAttributeTypes={setUserAttributeTypes}
                userAttributeTypes={userAttributeTypes}
              />
            </>
          )}
          {showAttributeEndTime && (
            <>
              {' to '}
              <StartOrEndTimePicker
                attribute={attribute}
                attributeTypeName={attributeTypeName}
                isStartTimePicker={false}
                setUserAttributeTypes={setUserAttributeTypes}
                userAttributeTypes={userAttributeTypes}
              />
            </>
          )}
        </div>
      ))}
    </>
  );
};

export default SingletonEditField;
